/**
 * Generated by orval v8.11.0 🍺
 * Do not edit manually.
 * Core API
 * Core API Documentation
 * OpenAPI spec version: 1.0
 */
import { useMutation, useQuery } from "@tanstack/react-query";
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult,
} from "@tanstack/react-query";

import type {
  AcknowledgementItemDetailDto,
  AcknowledgementItemListDto,
  AcknowledgementRecordListDto,
  AcknowledgementReportResponseDto,
  AcknowledgementRequestDetailDto,
  AcknowledgementTrackingQueryControllerListItemsParams,
  AcknowledgementTrackingQueryControllerReportParams,
  AcknowledgementTrackingQueryControllerStaffAcknowledgementsParams,
  ArchiveAcknowledgeableItemResponseDto,
  BackfillEventRecordRequestsDto,
  BackfillEventRecordRequestsResponseDto,
  ListMyAcknowledgementsQueryControllerMyRecordsParams,
  ListMyAcknowledgementsQueryControllerMyRequestsParams,
  MarkAcknowledgementReadDto,
  MarkAcknowledgementReadResponseDto,
  MyAcknowledgementRequestDto,
  PublishAcknowledgementItemDto,
  PublishAcknowledgementItemResponseDto,
  RemindAcknowledgementResponseDto,
  RemindAllAcknowledgementsResponseDto,
  SignAcknowledgementDto,
  SignAcknowledgementResponseDto,
  StaffAcknowledgementsDto,
} from "../model";

import { axiosClient } from "../../lib/api";

type AwaitedInput<T> = PromiseLike<T> | T;

type Awaited<O> = O extends AwaitedInput<infer T> ? T : never;

/**
 * Publishes a version of an item and raises one acknowledgement request per person in scope. Publishing a new version of the same item supersedes the previous one and voids its outstanding requests, so nobody is chased about an out-of-date document — signed records against earlier versions are kept. Manager and above.
 * @summary Send an item to staff for acknowledgement
 */
export const publishAcknowledgementItemCommandControllerPublish = (
  nurseryId: string,
  publishAcknowledgementItemDto: PublishAcknowledgementItemDto,
  signal?: AbortSignal,
) => {
  return axiosClient<PublishAcknowledgementItemResponseDto>({
    url: `/v1/nurseries/${nurseryId}/acknowledgements/items`,
    method: "POST",
    headers: { "Content-Type": "application/json" },
    data: publishAcknowledgementItemDto,
    signal,
  });
};

export const getPublishAcknowledgementItemCommandControllerPublishMutationOptions =
  <TError = void, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<typeof publishAcknowledgementItemCommandControllerPublish>
      >,
      TError,
      { nurseryId: string; data: PublishAcknowledgementItemDto },
      TContext
    >;
  }): UseMutationOptions<
    Awaited<
      ReturnType<typeof publishAcknowledgementItemCommandControllerPublish>
    >,
    TError,
    { nurseryId: string; data: PublishAcknowledgementItemDto },
    TContext
  > => {
    const mutationKey = ["publishAcknowledgementItemCommandControllerPublish"];
    const { mutation: mutationOptions } = options
      ? options.mutation &&
        "mutationKey" in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<typeof publishAcknowledgementItemCommandControllerPublish>
      >,
      { nurseryId: string; data: PublishAcknowledgementItemDto }
    > = (props) => {
      const { nurseryId, data } = props ?? {};

      return publishAcknowledgementItemCommandControllerPublish(
        nurseryId,
        data,
      );
    };

    return { mutationFn, ...mutationOptions };
  };

export type PublishAcknowledgementItemCommandControllerPublishMutationResult =
  NonNullable<
    Awaited<
      ReturnType<typeof publishAcknowledgementItemCommandControllerPublish>
    >
  >;
export type PublishAcknowledgementItemCommandControllerPublishMutationBody =
  PublishAcknowledgementItemDto;
export type PublishAcknowledgementItemCommandControllerPublishMutationError =
  void;

/**
 * @summary Send an item to staff for acknowledgement
 */
export const usePublishAcknowledgementItemCommandControllerPublish = <
  TError = void,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<typeof publishAcknowledgementItemCommandControllerPublish>
      >,
      TError,
      { nurseryId: string; data: PublishAcknowledgementItemDto },
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<
    ReturnType<typeof publishAcknowledgementItemCommandControllerPublish>
  >,
  TError,
  { nurseryId: string; data: PublishAcknowledgementItemDto },
  TContext
> => {
  return useMutation(
    getPublishAcknowledgementItemCommandControllerPublishMutationOptions(
      options,
    ),
    queryClient,
  );
};
/**
 * Everything published for acknowledgement, newest first, each with its completion tiles. Superseded versions are hidden unless you ask for them. Deputy manager and above.
 * @summary Items sent for acknowledgement at this nursery
 */
export const acknowledgementTrackingQueryControllerListItems = (
  nurseryId: string,
  params?: AcknowledgementTrackingQueryControllerListItemsParams,
  signal?: AbortSignal,
) => {
  return axiosClient<AcknowledgementItemListDto>({
    url: `/v1/nurseries/${nurseryId}/acknowledgements/items`,
    method: "GET",
    params,
    signal,
  });
};

export const getAcknowledgementTrackingQueryControllerListItemsQueryKey = (
  nurseryId: string,
  params?: AcknowledgementTrackingQueryControllerListItemsParams,
) => {
  return [
    `/v1/nurseries/${nurseryId}/acknowledgements/items`,
    ...(params ? [params] : []),
  ] as const;
};

export const getAcknowledgementTrackingQueryControllerListItemsQueryOptions = <
  TData = Awaited<
    ReturnType<typeof acknowledgementTrackingQueryControllerListItems>
  >,
  TError = void,
>(
  nurseryId: string,
  params?: AcknowledgementTrackingQueryControllerListItemsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof acknowledgementTrackingQueryControllerListItems>
        >,
        TError,
        TData
      >
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getAcknowledgementTrackingQueryControllerListItemsQueryKey(
      nurseryId,
      params,
    );

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof acknowledgementTrackingQueryControllerListItems>>
  > = ({ signal }) =>
    acknowledgementTrackingQueryControllerListItems(nurseryId, params, signal);

  return {
    queryKey,
    queryFn,
    enabled: nurseryId !== null && nurseryId !== undefined,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof acknowledgementTrackingQueryControllerListItems>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type AcknowledgementTrackingQueryControllerListItemsQueryResult =
  NonNullable<
    Awaited<ReturnType<typeof acknowledgementTrackingQueryControllerListItems>>
  >;
export type AcknowledgementTrackingQueryControllerListItemsQueryError = void;

export function useAcknowledgementTrackingQueryControllerListItems<
  TData = Awaited<
    ReturnType<typeof acknowledgementTrackingQueryControllerListItems>
  >,
  TError = void,
>(
  nurseryId: string,
  params: undefined | AcknowledgementTrackingQueryControllerListItemsParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof acknowledgementTrackingQueryControllerListItems>
        >,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<
            ReturnType<typeof acknowledgementTrackingQueryControllerListItems>
          >,
          TError,
          Awaited<
            ReturnType<typeof acknowledgementTrackingQueryControllerListItems>
          >
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useAcknowledgementTrackingQueryControllerListItems<
  TData = Awaited<
    ReturnType<typeof acknowledgementTrackingQueryControllerListItems>
  >,
  TError = void,
>(
  nurseryId: string,
  params?: AcknowledgementTrackingQueryControllerListItemsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof acknowledgementTrackingQueryControllerListItems>
        >,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<
            ReturnType<typeof acknowledgementTrackingQueryControllerListItems>
          >,
          TError,
          Awaited<
            ReturnType<typeof acknowledgementTrackingQueryControllerListItems>
          >
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useAcknowledgementTrackingQueryControllerListItems<
  TData = Awaited<
    ReturnType<typeof acknowledgementTrackingQueryControllerListItems>
  >,
  TError = void,
>(
  nurseryId: string,
  params?: AcknowledgementTrackingQueryControllerListItemsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof acknowledgementTrackingQueryControllerListItems>
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Items sent for acknowledgement at this nursery
 */

export function useAcknowledgementTrackingQueryControllerListItems<
  TData = Awaited<
    ReturnType<typeof acknowledgementTrackingQueryControllerListItems>
  >,
  TError = void,
>(
  nurseryId: string,
  params?: AcknowledgementTrackingQueryControllerListItemsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof acknowledgementTrackingQueryControllerListItems>
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions =
    getAcknowledgementTrackingQueryControllerListItemsQueryOptions(
      nurseryId,
      params,
      options,
    );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * Records AC15's "Read" state. Idempotent: calling it again appends to the audit trail but leaves the first-read timestamp alone, which is the one the permanent record carries. Only the person asked can call this — a manager previewing the roster must not mark a document read on somebody's behalf.
 * @summary Record that you have opened the document
 */
export const acknowledgeRequestCommandControllerMarkRead = (
  requestId: string,
  markAcknowledgementReadDto: MarkAcknowledgementReadDto,
  signal?: AbortSignal,
) => {
  return axiosClient<MarkAcknowledgementReadResponseDto>({
    url: `/v1/acknowledgements/requests/${requestId}/read`,
    method: "POST",
    headers: { "Content-Type": "application/json" },
    data: markAcknowledgementReadDto,
    signal,
  });
};

export const getAcknowledgeRequestCommandControllerMarkReadMutationOptions = <
  TError = void,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof acknowledgeRequestCommandControllerMarkRead>>,
    TError,
    { requestId: string; data: MarkAcknowledgementReadDto },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof acknowledgeRequestCommandControllerMarkRead>>,
  TError,
  { requestId: string; data: MarkAcknowledgementReadDto },
  TContext
> => {
  const mutationKey = ["acknowledgeRequestCommandControllerMarkRead"];
  const { mutation: mutationOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof acknowledgeRequestCommandControllerMarkRead>>,
    { requestId: string; data: MarkAcknowledgementReadDto }
  > = (props) => {
    const { requestId, data } = props ?? {};

    return acknowledgeRequestCommandControllerMarkRead(requestId, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type AcknowledgeRequestCommandControllerMarkReadMutationResult =
  NonNullable<
    Awaited<ReturnType<typeof acknowledgeRequestCommandControllerMarkRead>>
  >;
export type AcknowledgeRequestCommandControllerMarkReadMutationBody =
  MarkAcknowledgementReadDto;
export type AcknowledgeRequestCommandControllerMarkReadMutationError = void;

/**
 * @summary Record that you have opened the document
 */
export const useAcknowledgeRequestCommandControllerMarkRead = <
  TError = void,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof acknowledgeRequestCommandControllerMarkRead>>,
      TError,
      { requestId: string; data: MarkAcknowledgementReadDto },
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof acknowledgeRequestCommandControllerMarkRead>>,
  TError,
  { requestId: string; data: MarkAcknowledgementReadDto },
  TContext
> => {
  return useMutation(
    getAcknowledgeRequestCommandControllerMarkReadMutationOptions(options),
    queryClient,
  );
};
/**
 * Creates the permanent, uneditable acknowledgement record. This cannot be undone, and no role can edit or delete the record afterwards. Idempotent on purpose: signing again returns the existing record with a 200 rather than a conflict, so an offline client replaying its queue does not report a failure for something that already succeeded.
 * @summary Confirm you have read and understood the document
 */
export const acknowledgeRequestCommandControllerSign = (
  requestId: string,
  signAcknowledgementDto: SignAcknowledgementDto,
  signal?: AbortSignal,
) => {
  return axiosClient<SignAcknowledgementResponseDto>({
    url: `/v1/acknowledgements/requests/${requestId}/sign`,
    method: "POST",
    headers: { "Content-Type": "application/json" },
    data: signAcknowledgementDto,
    signal,
  });
};

export const getAcknowledgeRequestCommandControllerSignMutationOptions = <
  TError = void,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof acknowledgeRequestCommandControllerSign>>,
    TError,
    { requestId: string; data: SignAcknowledgementDto },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof acknowledgeRequestCommandControllerSign>>,
  TError,
  { requestId: string; data: SignAcknowledgementDto },
  TContext
> => {
  const mutationKey = ["acknowledgeRequestCommandControllerSign"];
  const { mutation: mutationOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof acknowledgeRequestCommandControllerSign>>,
    { requestId: string; data: SignAcknowledgementDto }
  > = (props) => {
    const { requestId, data } = props ?? {};

    return acknowledgeRequestCommandControllerSign(requestId, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type AcknowledgeRequestCommandControllerSignMutationResult = NonNullable<
  Awaited<ReturnType<typeof acknowledgeRequestCommandControllerSign>>
>;
export type AcknowledgeRequestCommandControllerSignMutationBody =
  SignAcknowledgementDto;
export type AcknowledgeRequestCommandControllerSignMutationError = void;

/**
 * @summary Confirm you have read and understood the document
 */
export const useAcknowledgeRequestCommandControllerSign = <
  TError = void,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof acknowledgeRequestCommandControllerSign>>,
      TError,
      { requestId: string; data: SignAcknowledgementDto },
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof acknowledgeRequestCommandControllerSign>>,
  TError,
  { requestId: string; data: SignAcknowledgementDto },
  TContext
> => {
  return useMutation(
    getAcknowledgeRequestCommandControllerSignMutationOptions(options),
    queryClient,
  );
};
/**
 * Records that this person was chased and updates the "last reminded" date on the tracking view. IMPORTANT: nothing is delivered — acknowledgement reminders are surfaced in-platform only, with no email and no push notification, so the staff member sees the request on their To do list exactly as before. Rate-limited to one reminder per request every 12 hours.
 * @summary Remind one person about an outstanding acknowledgement
 */
export const manageAcknowledgementItemCommandControllerRemind = (
  requestId: string,
  signal?: AbortSignal,
) => {
  return axiosClient<RemindAcknowledgementResponseDto>({
    url: `/v1/acknowledgements/requests/${requestId}/remind`,
    method: "POST",
    signal,
  });
};

export const getManageAcknowledgementItemCommandControllerRemindMutationOptions =
  <TError = void, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<typeof manageAcknowledgementItemCommandControllerRemind>
      >,
      TError,
      { requestId: string },
      TContext
    >;
  }): UseMutationOptions<
    Awaited<
      ReturnType<typeof manageAcknowledgementItemCommandControllerRemind>
    >,
    TError,
    { requestId: string },
    TContext
  > => {
    const mutationKey = ["manageAcknowledgementItemCommandControllerRemind"];
    const { mutation: mutationOptions } = options
      ? options.mutation &&
        "mutationKey" in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<typeof manageAcknowledgementItemCommandControllerRemind>
      >,
      { requestId: string }
    > = (props) => {
      const { requestId } = props ?? {};

      return manageAcknowledgementItemCommandControllerRemind(requestId);
    };

    return { mutationFn, ...mutationOptions };
  };

export type ManageAcknowledgementItemCommandControllerRemindMutationResult =
  NonNullable<
    Awaited<ReturnType<typeof manageAcknowledgementItemCommandControllerRemind>>
  >;

export type ManageAcknowledgementItemCommandControllerRemindMutationError =
  void;

/**
 * @summary Remind one person about an outstanding acknowledgement
 */
export const useManageAcknowledgementItemCommandControllerRemind = <
  TError = void,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<typeof manageAcknowledgementItemCommandControllerRemind>
      >,
      TError,
      { requestId: string },
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof manageAcknowledgementItemCommandControllerRemind>>,
  TError,
  { requestId: string },
  TContext
> => {
  return useMutation(
    getManageAcknowledgementItemCommandControllerRemindMutationOptions(options),
    queryClient,
  );
};
/**
 * Chases every outstanding request for this version at once. Anyone reminded within the last 12 hours is skipped rather than failing the batch, so a double-click is harmless. As with a single reminder, nothing is delivered — this is in-platform only.
 * @summary Remind everyone with an outstanding acknowledgement
 */
export const manageAcknowledgementItemCommandControllerRemindAll = (
  itemVersionId: string,
  signal?: AbortSignal,
) => {
  return axiosClient<RemindAllAcknowledgementsResponseDto>({
    url: `/v1/acknowledgements/items/${itemVersionId}/remind-all`,
    method: "POST",
    signal,
  });
};

export const getManageAcknowledgementItemCommandControllerRemindAllMutationOptions =
  <TError = void, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<typeof manageAcknowledgementItemCommandControllerRemindAll>
      >,
      TError,
      { itemVersionId: string },
      TContext
    >;
  }): UseMutationOptions<
    Awaited<
      ReturnType<typeof manageAcknowledgementItemCommandControllerRemindAll>
    >,
    TError,
    { itemVersionId: string },
    TContext
  > => {
    const mutationKey = ["manageAcknowledgementItemCommandControllerRemindAll"];
    const { mutation: mutationOptions } = options
      ? options.mutation &&
        "mutationKey" in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<typeof manageAcknowledgementItemCommandControllerRemindAll>
      >,
      { itemVersionId: string }
    > = (props) => {
      const { itemVersionId } = props ?? {};

      return manageAcknowledgementItemCommandControllerRemindAll(itemVersionId);
    };

    return { mutationFn, ...mutationOptions };
  };

export type ManageAcknowledgementItemCommandControllerRemindAllMutationResult =
  NonNullable<
    Awaited<
      ReturnType<typeof manageAcknowledgementItemCommandControllerRemindAll>
    >
  >;

export type ManageAcknowledgementItemCommandControllerRemindAllMutationError =
  void;

/**
 * @summary Remind everyone with an outstanding acknowledgement
 */
export const useManageAcknowledgementItemCommandControllerRemindAll = <
  TError = void,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<typeof manageAcknowledgementItemCommandControllerRemindAll>
      >,
      TError,
      { itemVersionId: string },
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<
    ReturnType<typeof manageAcknowledgementItemCommandControllerRemindAll>
  >,
  TError,
  { itemVersionId: string },
  TContext
> => {
  return useMutation(
    getManageAcknowledgementItemCommandControllerRemindAllMutationOptions(
      options,
    ),
    queryClient,
  );
};
/**
 * Hides the item from the current list. Nothing is deleted: every acknowledgement record against it stays retrievable afterwards, which is what makes the compliance history complete. Manager and above.
 * @summary Archive a published item
 */
export const manageAcknowledgementItemCommandControllerArchive = (
  itemVersionId: string,
  signal?: AbortSignal,
) => {
  return axiosClient<ArchiveAcknowledgeableItemResponseDto>({
    url: `/v1/acknowledgements/items/${itemVersionId}/archive`,
    method: "POST",
    signal,
  });
};

export const getManageAcknowledgementItemCommandControllerArchiveMutationOptions =
  <TError = void, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<typeof manageAcknowledgementItemCommandControllerArchive>
      >,
      TError,
      { itemVersionId: string },
      TContext
    >;
  }): UseMutationOptions<
    Awaited<
      ReturnType<typeof manageAcknowledgementItemCommandControllerArchive>
    >,
    TError,
    { itemVersionId: string },
    TContext
  > => {
    const mutationKey = ["manageAcknowledgementItemCommandControllerArchive"];
    const { mutation: mutationOptions } = options
      ? options.mutation &&
        "mutationKey" in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<typeof manageAcknowledgementItemCommandControllerArchive>
      >,
      { itemVersionId: string }
    > = (props) => {
      const { itemVersionId } = props ?? {};

      return manageAcknowledgementItemCommandControllerArchive(itemVersionId);
    };

    return { mutationFn, ...mutationOptions };
  };

export type ManageAcknowledgementItemCommandControllerArchiveMutationResult =
  NonNullable<
    Awaited<
      ReturnType<typeof manageAcknowledgementItemCommandControllerArchive>
    >
  >;

export type ManageAcknowledgementItemCommandControllerArchiveMutationError =
  void;

/**
 * @summary Archive a published item
 */
export const useManageAcknowledgementItemCommandControllerArchive = <
  TError = void,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<typeof manageAcknowledgementItemCommandControllerArchive>
      >,
      TError,
      { itemVersionId: string },
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof manageAcknowledgementItemCommandControllerArchive>>,
  TError,
  { itemVersionId: string },
  TContext
> => {
  return useMutation(
    getManageAcknowledgementItemCommandControllerArchiveMutationOptions(
      options,
    ),
    queryClient,
  );
};
/**
 * One-off, idempotent endpoint copying pre-NAU-410 incident acknowledgement requests into the shared acknowledgement tables, preserving the original timestamps. MUST be run immediately after deploy: the read path no longer looks at the legacy table, so until this has run every request raised beforehand is invisible on the record detail page and uncounted in the Awaiting tab. Safe to re-run — rows that already have an equivalent are reported as reconciled and left alone. The legacy table is not modified, so a rollback stays possible until the follow-up ticket drops it.
 * @summary Backfill legacy incident acknowledgement requests (platform admin only)
 */
export const backfillEventRecordRequestsCommandControllerBackfill = (
  backfillEventRecordRequestsDto?: BackfillEventRecordRequestsDto,
  signal?: AbortSignal,
) => {
  return axiosClient<BackfillEventRecordRequestsResponseDto>({
    url: `/v1/acknowledgements/backfill-event-record-requests`,
    method: "POST",
    headers: { "Content-Type": "application/json" },
    data: backfillEventRecordRequestsDto,
    signal,
  });
};

export const getBackfillEventRecordRequestsCommandControllerBackfillMutationOptions =
  <TError = void, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<typeof backfillEventRecordRequestsCommandControllerBackfill>
      >,
      TError,
      { data?: BackfillEventRecordRequestsDto },
      TContext
    >;
  }): UseMutationOptions<
    Awaited<
      ReturnType<typeof backfillEventRecordRequestsCommandControllerBackfill>
    >,
    TError,
    { data?: BackfillEventRecordRequestsDto },
    TContext
  > => {
    const mutationKey = [
      "backfillEventRecordRequestsCommandControllerBackfill",
    ];
    const { mutation: mutationOptions } = options
      ? options.mutation &&
        "mutationKey" in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<typeof backfillEventRecordRequestsCommandControllerBackfill>
      >,
      { data?: BackfillEventRecordRequestsDto }
    > = (props) => {
      const { data } = props ?? {};

      return backfillEventRecordRequestsCommandControllerBackfill(data);
    };

    return { mutationFn, ...mutationOptions };
  };

export type BackfillEventRecordRequestsCommandControllerBackfillMutationResult =
  NonNullable<
    Awaited<
      ReturnType<typeof backfillEventRecordRequestsCommandControllerBackfill>
    >
  >;
export type BackfillEventRecordRequestsCommandControllerBackfillMutationBody =
  | BackfillEventRecordRequestsDto
  | undefined;
export type BackfillEventRecordRequestsCommandControllerBackfillMutationError =
  void;

/**
 * @summary Backfill legacy incident acknowledgement requests (platform admin only)
 */
export const useBackfillEventRecordRequestsCommandControllerBackfill = <
  TError = void,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<typeof backfillEventRecordRequestsCommandControllerBackfill>
      >,
      TError,
      { data?: BackfillEventRecordRequestsDto },
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<
    ReturnType<typeof backfillEventRecordRequestsCommandControllerBackfill>
  >,
  TError,
  { data?: BackfillEventRecordRequestsDto },
  TContext
> => {
  return useMutation(
    getBackfillEventRecordRequestsCommandControllerBackfillMutationOptions(
      options,
    ),
    queryClient,
  );
};
/**
 * Returns the request plus the document itself, so it can be read in the platform before confirming. The person asked can always open it — holding the request is the authorisation, which matters because a document's own visibility rules can be narrower than who it was sent to. A deputy manager or above can also open it to see what was sent, but only the person asked can sign.
 * @summary Read the document you have been asked to acknowledge
 */
export const getAcknowledgementRequestQueryControllerGet = (
  requestId: string,
  signal?: AbortSignal,
) => {
  return axiosClient<AcknowledgementRequestDetailDto>({
    url: `/v1/acknowledgements/requests/${requestId}`,
    method: "GET",
    signal,
  });
};

export const getGetAcknowledgementRequestQueryControllerGetQueryKey = (
  requestId: string,
) => {
  return [`/v1/acknowledgements/requests/${requestId}`] as const;
};

export const getGetAcknowledgementRequestQueryControllerGetQueryOptions = <
  TData = Awaited<
    ReturnType<typeof getAcknowledgementRequestQueryControllerGet>
  >,
  TError = void,
>(
  requestId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getAcknowledgementRequestQueryControllerGet>>,
        TError,
        TData
      >
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getGetAcknowledgementRequestQueryControllerGetQueryKey(requestId);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getAcknowledgementRequestQueryControllerGet>>
  > = ({ signal }) =>
    getAcknowledgementRequestQueryControllerGet(requestId, signal);

  return {
    queryKey,
    queryFn,
    enabled: requestId !== null && requestId !== undefined,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getAcknowledgementRequestQueryControllerGet>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetAcknowledgementRequestQueryControllerGetQueryResult =
  NonNullable<
    Awaited<ReturnType<typeof getAcknowledgementRequestQueryControllerGet>>
  >;
export type GetAcknowledgementRequestQueryControllerGetQueryError = void;

export function useGetAcknowledgementRequestQueryControllerGet<
  TData = Awaited<
    ReturnType<typeof getAcknowledgementRequestQueryControllerGet>
  >,
  TError = void,
>(
  requestId: string,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getAcknowledgementRequestQueryControllerGet>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<
            ReturnType<typeof getAcknowledgementRequestQueryControllerGet>
          >,
          TError,
          Awaited<
            ReturnType<typeof getAcknowledgementRequestQueryControllerGet>
          >
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetAcknowledgementRequestQueryControllerGet<
  TData = Awaited<
    ReturnType<typeof getAcknowledgementRequestQueryControllerGet>
  >,
  TError = void,
>(
  requestId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getAcknowledgementRequestQueryControllerGet>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<
            ReturnType<typeof getAcknowledgementRequestQueryControllerGet>
          >,
          TError,
          Awaited<
            ReturnType<typeof getAcknowledgementRequestQueryControllerGet>
          >
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetAcknowledgementRequestQueryControllerGet<
  TData = Awaited<
    ReturnType<typeof getAcknowledgementRequestQueryControllerGet>
  >,
  TError = void,
>(
  requestId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getAcknowledgementRequestQueryControllerGet>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Read the document you have been asked to acknowledge
 */

export function useGetAcknowledgementRequestQueryControllerGet<
  TData = Awaited<
    ReturnType<typeof getAcknowledgementRequestQueryControllerGet>
  >,
  TError = void,
>(
  requestId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getAcknowledgementRequestQueryControllerGet>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions =
    getGetAcknowledgementRequestQueryControllerGetQueryOptions(
      requestId,
      options,
    );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * What you still have to read and sign. This is what puts an item on a staff member's To do list, and it stays there until they sign it. Requests voided by a newer version are excluded — nobody has to acknowledge an out-of-date document.
 * @summary Your own acknowledgement requests
 */
export const listMyAcknowledgementsQueryControllerMyRequests = (
  nurseryId: string,
  params?: ListMyAcknowledgementsQueryControllerMyRequestsParams,
  signal?: AbortSignal,
) => {
  return axiosClient<MyAcknowledgementRequestDto[]>({
    url: `/v1/nurseries/${nurseryId}/acknowledgements/me/requests`,
    method: "GET",
    params,
    signal,
  });
};

export const getListMyAcknowledgementsQueryControllerMyRequestsQueryKey = (
  nurseryId: string,
  params?: ListMyAcknowledgementsQueryControllerMyRequestsParams,
) => {
  return [
    `/v1/nurseries/${nurseryId}/acknowledgements/me/requests`,
    ...(params ? [params] : []),
  ] as const;
};

export const getListMyAcknowledgementsQueryControllerMyRequestsQueryOptions = <
  TData = Awaited<
    ReturnType<typeof listMyAcknowledgementsQueryControllerMyRequests>
  >,
  TError = void,
>(
  nurseryId: string,
  params?: ListMyAcknowledgementsQueryControllerMyRequestsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof listMyAcknowledgementsQueryControllerMyRequests>
        >,
        TError,
        TData
      >
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getListMyAcknowledgementsQueryControllerMyRequestsQueryKey(
      nurseryId,
      params,
    );

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof listMyAcknowledgementsQueryControllerMyRequests>>
  > = ({ signal }) =>
    listMyAcknowledgementsQueryControllerMyRequests(nurseryId, params, signal);

  return {
    queryKey,
    queryFn,
    enabled: nurseryId !== null && nurseryId !== undefined,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof listMyAcknowledgementsQueryControllerMyRequests>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type ListMyAcknowledgementsQueryControllerMyRequestsQueryResult =
  NonNullable<
    Awaited<ReturnType<typeof listMyAcknowledgementsQueryControllerMyRequests>>
  >;
export type ListMyAcknowledgementsQueryControllerMyRequestsQueryError = void;

export function useListMyAcknowledgementsQueryControllerMyRequests<
  TData = Awaited<
    ReturnType<typeof listMyAcknowledgementsQueryControllerMyRequests>
  >,
  TError = void,
>(
  nurseryId: string,
  params: undefined | ListMyAcknowledgementsQueryControllerMyRequestsParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof listMyAcknowledgementsQueryControllerMyRequests>
        >,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<
            ReturnType<typeof listMyAcknowledgementsQueryControllerMyRequests>
          >,
          TError,
          Awaited<
            ReturnType<typeof listMyAcknowledgementsQueryControllerMyRequests>
          >
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useListMyAcknowledgementsQueryControllerMyRequests<
  TData = Awaited<
    ReturnType<typeof listMyAcknowledgementsQueryControllerMyRequests>
  >,
  TError = void,
>(
  nurseryId: string,
  params?: ListMyAcknowledgementsQueryControllerMyRequestsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof listMyAcknowledgementsQueryControllerMyRequests>
        >,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<
            ReturnType<typeof listMyAcknowledgementsQueryControllerMyRequests>
          >,
          TError,
          Awaited<
            ReturnType<typeof listMyAcknowledgementsQueryControllerMyRequests>
          >
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useListMyAcknowledgementsQueryControllerMyRequests<
  TData = Awaited<
    ReturnType<typeof listMyAcknowledgementsQueryControllerMyRequests>
  >,
  TError = void,
>(
  nurseryId: string,
  params?: ListMyAcknowledgementsQueryControllerMyRequestsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof listMyAcknowledgementsQueryControllerMyRequests>
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Your own acknowledgement requests
 */

export function useListMyAcknowledgementsQueryControllerMyRequests<
  TData = Awaited<
    ReturnType<typeof listMyAcknowledgementsQueryControllerMyRequests>
  >,
  TError = void,
>(
  nurseryId: string,
  params?: ListMyAcknowledgementsQueryControllerMyRequestsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof listMyAcknowledgementsQueryControllerMyRequests>
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions =
    getListMyAcknowledgementsQueryControllerMyRequestsQueryOptions(
      nurseryId,
      params,
      options,
    );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * Everything you have previously acknowledged, newest first — including acknowledgements against versions that have since been replaced, which are flagged as superseded. These records are permanent and cannot be edited or deleted by anyone.
 * @summary Your acknowledgement history
 */
export const listMyAcknowledgementsQueryControllerMyRecords = (
  nurseryId: string,
  params?: ListMyAcknowledgementsQueryControllerMyRecordsParams,
  signal?: AbortSignal,
) => {
  return axiosClient<AcknowledgementRecordListDto>({
    url: `/v1/nurseries/${nurseryId}/acknowledgements/me/records`,
    method: "GET",
    params,
    signal,
  });
};

export const getListMyAcknowledgementsQueryControllerMyRecordsQueryKey = (
  nurseryId: string,
  params?: ListMyAcknowledgementsQueryControllerMyRecordsParams,
) => {
  return [
    `/v1/nurseries/${nurseryId}/acknowledgements/me/records`,
    ...(params ? [params] : []),
  ] as const;
};

export const getListMyAcknowledgementsQueryControllerMyRecordsQueryOptions = <
  TData = Awaited<
    ReturnType<typeof listMyAcknowledgementsQueryControllerMyRecords>
  >,
  TError = void,
>(
  nurseryId: string,
  params?: ListMyAcknowledgementsQueryControllerMyRecordsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof listMyAcknowledgementsQueryControllerMyRecords>
        >,
        TError,
        TData
      >
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getListMyAcknowledgementsQueryControllerMyRecordsQueryKey(
      nurseryId,
      params,
    );

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof listMyAcknowledgementsQueryControllerMyRecords>>
  > = ({ signal }) =>
    listMyAcknowledgementsQueryControllerMyRecords(nurseryId, params, signal);

  return {
    queryKey,
    queryFn,
    enabled: nurseryId !== null && nurseryId !== undefined,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof listMyAcknowledgementsQueryControllerMyRecords>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type ListMyAcknowledgementsQueryControllerMyRecordsQueryResult =
  NonNullable<
    Awaited<ReturnType<typeof listMyAcknowledgementsQueryControllerMyRecords>>
  >;
export type ListMyAcknowledgementsQueryControllerMyRecordsQueryError = void;

export function useListMyAcknowledgementsQueryControllerMyRecords<
  TData = Awaited<
    ReturnType<typeof listMyAcknowledgementsQueryControllerMyRecords>
  >,
  TError = void,
>(
  nurseryId: string,
  params: undefined | ListMyAcknowledgementsQueryControllerMyRecordsParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof listMyAcknowledgementsQueryControllerMyRecords>
        >,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<
            ReturnType<typeof listMyAcknowledgementsQueryControllerMyRecords>
          >,
          TError,
          Awaited<
            ReturnType<typeof listMyAcknowledgementsQueryControllerMyRecords>
          >
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useListMyAcknowledgementsQueryControllerMyRecords<
  TData = Awaited<
    ReturnType<typeof listMyAcknowledgementsQueryControllerMyRecords>
  >,
  TError = void,
>(
  nurseryId: string,
  params?: ListMyAcknowledgementsQueryControllerMyRecordsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof listMyAcknowledgementsQueryControllerMyRecords>
        >,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<
            ReturnType<typeof listMyAcknowledgementsQueryControllerMyRecords>
          >,
          TError,
          Awaited<
            ReturnType<typeof listMyAcknowledgementsQueryControllerMyRecords>
          >
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useListMyAcknowledgementsQueryControllerMyRecords<
  TData = Awaited<
    ReturnType<typeof listMyAcknowledgementsQueryControllerMyRecords>
  >,
  TError = void,
>(
  nurseryId: string,
  params?: ListMyAcknowledgementsQueryControllerMyRecordsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof listMyAcknowledgementsQueryControllerMyRecords>
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Your acknowledgement history
 */

export function useListMyAcknowledgementsQueryControllerMyRecords<
  TData = Awaited<
    ReturnType<typeof listMyAcknowledgementsQueryControllerMyRecords>
  >,
  TError = void,
>(
  nurseryId: string,
  params?: ListMyAcknowledgementsQueryControllerMyRecordsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof listMyAcknowledgementsQueryControllerMyRecords>
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions =
    getListMyAcknowledgementsQueryControllerMyRecordsQueryOptions(
      nurseryId,
      params,
      options,
    );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * The tracking view for one published version: completion tiles, and every person in scope with their read date, signed date and the date they were last reminded. Deputy manager and above.
 * @summary Who has and has not acknowledged this item
 */
export const acknowledgementTrackingQueryControllerGetItem = (
  itemVersionId: string,
  signal?: AbortSignal,
) => {
  return axiosClient<AcknowledgementItemDetailDto>({
    url: `/v1/acknowledgements/items/${itemVersionId}`,
    method: "GET",
    signal,
  });
};

export const getAcknowledgementTrackingQueryControllerGetItemQueryKey = (
  itemVersionId: string,
) => {
  return [`/v1/acknowledgements/items/${itemVersionId}`] as const;
};

export const getAcknowledgementTrackingQueryControllerGetItemQueryOptions = <
  TData = Awaited<
    ReturnType<typeof acknowledgementTrackingQueryControllerGetItem>
  >,
  TError = void,
>(
  itemVersionId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof acknowledgementTrackingQueryControllerGetItem>
        >,
        TError,
        TData
      >
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getAcknowledgementTrackingQueryControllerGetItemQueryKey(itemVersionId);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof acknowledgementTrackingQueryControllerGetItem>>
  > = ({ signal }) =>
    acknowledgementTrackingQueryControllerGetItem(itemVersionId, signal);

  return {
    queryKey,
    queryFn,
    enabled: itemVersionId !== null && itemVersionId !== undefined,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof acknowledgementTrackingQueryControllerGetItem>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type AcknowledgementTrackingQueryControllerGetItemQueryResult =
  NonNullable<
    Awaited<ReturnType<typeof acknowledgementTrackingQueryControllerGetItem>>
  >;
export type AcknowledgementTrackingQueryControllerGetItemQueryError = void;

export function useAcknowledgementTrackingQueryControllerGetItem<
  TData = Awaited<
    ReturnType<typeof acknowledgementTrackingQueryControllerGetItem>
  >,
  TError = void,
>(
  itemVersionId: string,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof acknowledgementTrackingQueryControllerGetItem>
        >,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<
            ReturnType<typeof acknowledgementTrackingQueryControllerGetItem>
          >,
          TError,
          Awaited<
            ReturnType<typeof acknowledgementTrackingQueryControllerGetItem>
          >
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useAcknowledgementTrackingQueryControllerGetItem<
  TData = Awaited<
    ReturnType<typeof acknowledgementTrackingQueryControllerGetItem>
  >,
  TError = void,
>(
  itemVersionId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof acknowledgementTrackingQueryControllerGetItem>
        >,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<
            ReturnType<typeof acknowledgementTrackingQueryControllerGetItem>
          >,
          TError,
          Awaited<
            ReturnType<typeof acknowledgementTrackingQueryControllerGetItem>
          >
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useAcknowledgementTrackingQueryControllerGetItem<
  TData = Awaited<
    ReturnType<typeof acknowledgementTrackingQueryControllerGetItem>
  >,
  TError = void,
>(
  itemVersionId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof acknowledgementTrackingQueryControllerGetItem>
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Who has and has not acknowledged this item
 */

export function useAcknowledgementTrackingQueryControllerGetItem<
  TData = Awaited<
    ReturnType<typeof acknowledgementTrackingQueryControllerGetItem>
  >,
  TError = void,
>(
  itemVersionId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof acknowledgementTrackingQueryControllerGetItem>
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions =
    getAcknowledgementTrackingQueryControllerGetItemQueryOptions(
      itemVersionId,
      options,
    );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * One row per person, for export. Returns data rather than a file: the client builds the CSV, so nothing is ever silently truncated — a report larger than the row cap is refused with a 400 instead. Deputy manager and above.
 * @summary Acknowledgement report for one item
 */
export const acknowledgementTrackingQueryControllerReport = (
  itemVersionId: string,
  params?: AcknowledgementTrackingQueryControllerReportParams,
  signal?: AbortSignal,
) => {
  return axiosClient<AcknowledgementReportResponseDto>({
    url: `/v1/acknowledgements/items/${itemVersionId}/report`,
    method: "GET",
    params,
    signal,
  });
};

export const getAcknowledgementTrackingQueryControllerReportQueryKey = (
  itemVersionId: string,
  params?: AcknowledgementTrackingQueryControllerReportParams,
) => {
  return [
    `/v1/acknowledgements/items/${itemVersionId}/report`,
    ...(params ? [params] : []),
  ] as const;
};

export const getAcknowledgementTrackingQueryControllerReportQueryOptions = <
  TData = Awaited<
    ReturnType<typeof acknowledgementTrackingQueryControllerReport>
  >,
  TError = void,
>(
  itemVersionId: string,
  params?: AcknowledgementTrackingQueryControllerReportParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof acknowledgementTrackingQueryControllerReport>
        >,
        TError,
        TData
      >
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getAcknowledgementTrackingQueryControllerReportQueryKey(
      itemVersionId,
      params,
    );

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof acknowledgementTrackingQueryControllerReport>>
  > = ({ signal }) =>
    acknowledgementTrackingQueryControllerReport(itemVersionId, params, signal);

  return {
    queryKey,
    queryFn,
    enabled: itemVersionId !== null && itemVersionId !== undefined,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof acknowledgementTrackingQueryControllerReport>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type AcknowledgementTrackingQueryControllerReportQueryResult =
  NonNullable<
    Awaited<ReturnType<typeof acknowledgementTrackingQueryControllerReport>>
  >;
export type AcknowledgementTrackingQueryControllerReportQueryError = void;

export function useAcknowledgementTrackingQueryControllerReport<
  TData = Awaited<
    ReturnType<typeof acknowledgementTrackingQueryControllerReport>
  >,
  TError = void,
>(
  itemVersionId: string,
  params: undefined | AcknowledgementTrackingQueryControllerReportParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof acknowledgementTrackingQueryControllerReport>
        >,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<
            ReturnType<typeof acknowledgementTrackingQueryControllerReport>
          >,
          TError,
          Awaited<
            ReturnType<typeof acknowledgementTrackingQueryControllerReport>
          >
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useAcknowledgementTrackingQueryControllerReport<
  TData = Awaited<
    ReturnType<typeof acknowledgementTrackingQueryControllerReport>
  >,
  TError = void,
>(
  itemVersionId: string,
  params?: AcknowledgementTrackingQueryControllerReportParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof acknowledgementTrackingQueryControllerReport>
        >,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<
            ReturnType<typeof acknowledgementTrackingQueryControllerReport>
          >,
          TError,
          Awaited<
            ReturnType<typeof acknowledgementTrackingQueryControllerReport>
          >
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useAcknowledgementTrackingQueryControllerReport<
  TData = Awaited<
    ReturnType<typeof acknowledgementTrackingQueryControllerReport>
  >,
  TError = void,
>(
  itemVersionId: string,
  params?: AcknowledgementTrackingQueryControllerReportParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof acknowledgementTrackingQueryControllerReport>
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Acknowledgement report for one item
 */

export function useAcknowledgementTrackingQueryControllerReport<
  TData = Awaited<
    ReturnType<typeof acknowledgementTrackingQueryControllerReport>
  >,
  TError = void,
>(
  itemVersionId: string,
  params?: AcknowledgementTrackingQueryControllerReportParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof acknowledgementTrackingQueryControllerReport>
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions =
    getAcknowledgementTrackingQueryControllerReportQueryOptions(
      itemVersionId,
      params,
      options,
    );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * The same records seen from the person's side: what this staff member still owes and everything they have signed. Deputy manager and above can view anyone; anyone can view their own.
 * @summary One person's acknowledgements
 */
export const acknowledgementTrackingQueryControllerStaffAcknowledgements = (
  nurseryId: string,
  staffUserId: string,
  params?: AcknowledgementTrackingQueryControllerStaffAcknowledgementsParams,
  signal?: AbortSignal,
) => {
  return axiosClient<StaffAcknowledgementsDto>({
    url: `/v1/nurseries/${nurseryId}/acknowledgements/staff/${staffUserId}`,
    method: "GET",
    params,
    signal,
  });
};

export const getAcknowledgementTrackingQueryControllerStaffAcknowledgementsQueryKey =
  (
    nurseryId: string,
    staffUserId: string,
    params?: AcknowledgementTrackingQueryControllerStaffAcknowledgementsParams,
  ) => {
    return [
      `/v1/nurseries/${nurseryId}/acknowledgements/staff/${staffUserId}`,
      ...(params ? [params] : []),
    ] as const;
  };

export const getAcknowledgementTrackingQueryControllerStaffAcknowledgementsQueryOptions =
  <
    TData = Awaited<
      ReturnType<
        typeof acknowledgementTrackingQueryControllerStaffAcknowledgements
      >
    >,
    TError = void,
  >(
    nurseryId: string,
    staffUserId: string,
    params?: AcknowledgementTrackingQueryControllerStaffAcknowledgementsParams,
    options?: {
      query?: Partial<
        UseQueryOptions<
          Awaited<
            ReturnType<
              typeof acknowledgementTrackingQueryControllerStaffAcknowledgements
            >
          >,
          TError,
          TData
        >
      >;
    },
  ) => {
    const { query: queryOptions } = options ?? {};

    const queryKey =
      queryOptions?.queryKey ??
      getAcknowledgementTrackingQueryControllerStaffAcknowledgementsQueryKey(
        nurseryId,
        staffUserId,
        params,
      );

    const queryFn: QueryFunction<
      Awaited<
        ReturnType<
          typeof acknowledgementTrackingQueryControllerStaffAcknowledgements
        >
      >
    > = ({ signal }) =>
      acknowledgementTrackingQueryControllerStaffAcknowledgements(
        nurseryId,
        staffUserId,
        params,
        signal,
      );

    return {
      queryKey,
      queryFn,
      enabled:
        nurseryId !== null &&
        nurseryId !== undefined &&
        staffUserId !== null &&
        staffUserId !== undefined,
      ...queryOptions,
    } as UseQueryOptions<
      Awaited<
        ReturnType<
          typeof acknowledgementTrackingQueryControllerStaffAcknowledgements
        >
      >,
      TError,
      TData
    > & { queryKey: DataTag<QueryKey, TData, TError> };
  };

export type AcknowledgementTrackingQueryControllerStaffAcknowledgementsQueryResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof acknowledgementTrackingQueryControllerStaffAcknowledgements
      >
    >
  >;
export type AcknowledgementTrackingQueryControllerStaffAcknowledgementsQueryError =
  void;

export function useAcknowledgementTrackingQueryControllerStaffAcknowledgements<
  TData = Awaited<
    ReturnType<
      typeof acknowledgementTrackingQueryControllerStaffAcknowledgements
    >
  >,
  TError = void,
>(
  nurseryId: string,
  staffUserId: string,
  params:
    | undefined
    | AcknowledgementTrackingQueryControllerStaffAcknowledgementsParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof acknowledgementTrackingQueryControllerStaffAcknowledgements
          >
        >,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof acknowledgementTrackingQueryControllerStaffAcknowledgements
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof acknowledgementTrackingQueryControllerStaffAcknowledgements
            >
          >
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useAcknowledgementTrackingQueryControllerStaffAcknowledgements<
  TData = Awaited<
    ReturnType<
      typeof acknowledgementTrackingQueryControllerStaffAcknowledgements
    >
  >,
  TError = void,
>(
  nurseryId: string,
  staffUserId: string,
  params?: AcknowledgementTrackingQueryControllerStaffAcknowledgementsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof acknowledgementTrackingQueryControllerStaffAcknowledgements
          >
        >,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof acknowledgementTrackingQueryControllerStaffAcknowledgements
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof acknowledgementTrackingQueryControllerStaffAcknowledgements
            >
          >
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useAcknowledgementTrackingQueryControllerStaffAcknowledgements<
  TData = Awaited<
    ReturnType<
      typeof acknowledgementTrackingQueryControllerStaffAcknowledgements
    >
  >,
  TError = void,
>(
  nurseryId: string,
  staffUserId: string,
  params?: AcknowledgementTrackingQueryControllerStaffAcknowledgementsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof acknowledgementTrackingQueryControllerStaffAcknowledgements
          >
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary One person's acknowledgements
 */

export function useAcknowledgementTrackingQueryControllerStaffAcknowledgements<
  TData = Awaited<
    ReturnType<
      typeof acknowledgementTrackingQueryControllerStaffAcknowledgements
    >
  >,
  TError = void,
>(
  nurseryId: string,
  staffUserId: string,
  params?: AcknowledgementTrackingQueryControllerStaffAcknowledgementsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof acknowledgementTrackingQueryControllerStaffAcknowledgements
          >
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions =
    getAcknowledgementTrackingQueryControllerStaffAcknowledgementsQueryOptions(
      nurseryId,
      staffUserId,
      params,
      options,
    );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}
